import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { PaginationPage } from "src/app/classes";
import { Contact, Customer } from "./classes";

export const CUSTOMER_PROVIDER_SERVICE = new InjectionToken<ICustomerProviderService>('CUSTOMER_PROVIDER_SERVICE');

export interface ICustomerProviderService {
    customerId$: Observable<number>;
    customer$: Observable<Customer>;
}

export const CUSTOMERS_PROVIDER_SERVICE = new InjectionToken<ICustomersProviderService>('CUSTOMERS_PROVIDER_SERVICE');

export interface ICustomersProviderService {
    customers$: Observable<Customer[]>;
}

export const CONTACT_PROVIDER_SERVICE = new InjectionToken<IContactProviderService>('CONTACT_PROVIDER_SERVICE');

export interface IContactProviderService {
    contactId$: Observable<number>;
    contact$: Observable<Contact>;
}

export const CONTACTS_PROVIDER_SERVICE = new InjectionToken<IContactsProviderService>('CONTACTS_PROVIDER_SERVICE');

export interface IContactsProviderService {
    contacts$: Observable<Contact[]>;
}

export const DEPARTMENTS_PROVIDER_SERVICE = new InjectionToken<IDepartmentsProviderService>('DEPARTMENTS_PROVIDER_SERVICE');

export interface IDepartmentsProviderService {
    departments$: Observable<string[]>;
    departmentPaginationPage$: Observable<PaginationPage>;
    departmentTotalItems$: Observable<number>;
    hasMoreDepartments$: Observable<boolean>;
    loadMoreDepartments(): void;
}
